'use strict';
import 'url-search-params-polyfill'; // IE-11

export default (API) => ({
    modules: {
        getModules: (params) => {
            const request = API.http.get('v3/modules', params);
            return API.handleError(request);
        },
        getSubmodules: () => {
            const request = API.http.get('v3/submodules');
            return API.handleError(request);
        }
    }
});
